import { Tooltip } from '@cobliteam/ui/components';
import { cn } from '@cobliteam/ui/utils';
import getStatusContent from './utils';

import type { DeviceGeneralStatus } from '@cobliteam/api-lib/src/__generated__/graphql';

import Icon, { type IconNames } from '@cobliteam/ui/icons';

interface StatusTagProps {
  status: DeviceGeneralStatus;
  width?: string;
  hideLabel?: boolean;
  showTooltip?: boolean;
  size?: 'xs' | 'sm' | 'md';
}

const StatusTag = ({ status, width, hideLabel, size = 'md', showTooltip = true }: StatusTagProps) => {
  const { iconName, colors, label, tooltip } = getStatusContent(status);

  const sizeClass = {
    xs: 'px-1.5 py-1 text-[10px] [&>svg]:!size-3',
    sm: 'px-2.5 py-1 text-xs',
    md: 'px-2.5 py-1',
  };

  const iconSize = {
    xs: '!size-3',
    sm: '!size-3',
    md: '!size-4',
  };

  const TagContent = () => (
    <div className={cn(['flex items-center justify-center gap-1 rounded-3xl', sizeClass[size], width || 'w-fit', colors])}>
      {iconName && <Icon name={iconName as IconNames} className={iconSize[size]} />}
      {hideLabel ? null : label}
    </div>
  );

  if (showTooltip) {
    return (
      <Tooltip content={tooltip} className='w-52' align='start' position='bottom'>
        <TagContent />
      </Tooltip>
    );
  }

  return <TagContent />;
};

export default StatusTag;
